// extracted by mini-css-extract-plugin
export default {"filesList":"FilesList_filesList__1r65Z","itemData":"FilesList_itemData__w0P01","fa":"FilesList_fa__c-Ts8"};